import { render, staticRenderFns } from "./business_areas_new.vue?vue&type=template&id=e111d644&scoped=true&"
import script from "./business_areas_new.vue?vue&type=script&lang=js&"
export * from "./business_areas_new.vue?vue&type=script&lang=js&"
import style0 from "./business_areas_new.vue?vue&type=style&index=0&id=e111d644&scoped=true&lang=scss&"
import style1 from "./business_areas_new.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e111d644",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e111d644')) {
      api.createRecord('e111d644', component.options)
    } else {
      api.reload('e111d644', component.options)
    }
    module.hot.accept("./business_areas_new.vue?vue&type=template&id=e111d644&scoped=true&", function () {
      api.rerender('e111d644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/business_areas_new.vue"
export default component.exports